/* eslint no-underscore-dangle: 0 */
import React, { useMemo, useEffect, useState } from 'react'
import settings from '@nobia/zeus-components/lib/settings'
import styled from '@nobia/zeus-components/lib/styled'
import Image from '@nobia/zeus-components/lib/image'

const ChatButtonStyled = styled.a`
  position: relative;
  font-size: 16px;
  border-radius: 4px;
  background-color: #cc9c74;
  padding: 13.5px;
  padding-left: 55px;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : 'none')};
  display: inline-block;
  text-align: center;

  &.disabled {
    opacity: 0.5;

    &:hover {
      cursor: not-allowed;
    }
  }

  img {
    position: absolute;
    border-radius: 50%;
    border: 3px solid white;
    top: 7px;
    left: 10px;
    width: 36px;
  }

  span {
    display: block;
  }

  ${(props) => props.theme.media.max.sm`
    height: 48px;
    font-size: 14px;
`};
`

const currentDateByZone = (inputDate) => {
  const localDate = inputDate
    .toLocaleString(settings.locale, {
      timeZone: settings.timeZone,
    })
    .replace(/,/g, '')

  const [, day, month, year, hours, minutes, seconds] = localDate.match(
    /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/
  )

  return new Date(year, month - 1, day, hours, minutes, seconds)
}

const ChatButton = () => {
  const [chatScriptLoadedInterval, setChatScriptLoadedInterval] = useState(0)
  const [chatScriptLoaded, setChatScriptLoaded] = useState(false)
  const [chatIsOpen, setChatIsOpen] = useState(false)
  const chatParameters = useMemo(() => {
    if (
      !window ||
      !window.__EmbedDependencies__ ||
      !window.__EmbedDependencies__.CHAT
    )
      return {}

    return window.__EmbedDependencies__.CHAT
  })

  if (!chatParameters.Enabled) return <></>

  const setChatIsOpenByTimeRanges = (
    currentTime,
    openingTimeStr,
    closingTimeStr
  ) => {
    if (!openingTimeStr || !closingTimeStr) {
      setChatIsOpen(false)
    } else {
      const openingTime = new Date(openingTimeStr)
      const closingTime = new Date(closingTimeStr)

      setChatIsOpen(openingTime < currentTime && currentTime < closingTime)
    }
  }

  const checkChatOpenStatus = () => {
    const currentTime = currentDateByZone(new Date())

    if (currentTime.getDay() !== 6 && currentTime.getDay() !== 0) {
      setChatIsOpenByTimeRanges(
        currentTime,
        chatParameters.OpeningTime,
        chatParameters.ClosingTime
      )
    } else {
      setChatIsOpenByTimeRanges(
        currentTime,
        chatParameters.OpeningWeekendTime,
        chatParameters.ClosingWeekendTime
      )
    }
  }

  useEffect(() => {
    checkChatOpenStatus()
    setInterval(() => checkChatOpenStatus(), 10000)

    if (!chatScriptLoadedInterval && !chatScriptLoaded) {
      const interval = setInterval(() => {
        if (window.fcWidget) {
          setChatScriptLoaded(true)
          clearInterval(interval)
        }
      }, 1000)
      setChatScriptLoadedInterval(interval)
    }
  }, [chatParameters])

  const onClick = (event) => {
    event.preventDefault()

    if (!chatIsOpen) return

    try {
      window.fcWidget.open()
      window.fcWidget.show()
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error on opening chat.')
      throw err
    }
  }

  return chatScriptLoaded ? (
    <ChatButtonStyled
      href="#"
      onClick={onClick}
      disabled={!chatIsOpen}
      className={chatIsOpen ? '' : 'disabled'}
    >
      <Image
        inlineWidth={36}
        inlineHeight={36}
        width={120}
        height={120}
        src={chatParameters.ChatButtonImageUrl}
      />
      {chatIsOpen ? chatParameters.OpenText : chatParameters.ClosedText}
    </ChatButtonStyled>
  ) : null
}

export default ChatButton
